import angular from 'angular';

import component from './experience-report.component';

const ExperienceReport = angular
    .module('control-room.experience-promoter.components.experience-report', [])
    .component('crExperienceReport', component);

export default ExperienceReport;
